import { render, staticRenderFns } from "./PaiementForm.vue?vue&type=template&id=f3f07744&"
import script from "./PaiementForm.vue?vue&type=script&lang=ts&"
export * from "./PaiementForm.vue?vue&type=script&lang=ts&"
import style0 from "./PaiementForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports